import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/AppRoutes';
import { ToastViewport } from '../shared/ui/ToastViewport';
import { PwaInstallToast } from '../features/sync/ui/PwaInstallToast';
import { useAuthStore } from '../features/auth/model/auth.store';
import { setUnauthorizedHandler } from '../shared/api/client';
import { showToast } from '../shared/ui/toast';

function AppShell() {
  const bootstrap = useAuthStore((state) => state.bootstrap);
  const handleUnauthorized = useAuthStore((state) => state.handleUnauthorized);
  const bootError = useAuthStore((state) => state.bootError);
  const status = useAuthStore((state) => state.status);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      void (async () => {
        await handleUnauthorized();
        showToast('Сессия истекла. Войдите снова.', 'error');
      })();
    });

    void bootstrap();

    return () => {
      setUnauthorizedHandler(null);
    };
  }, [bootstrap, handleUnauthorized]);

  useEffect(() => {
    if (bootError && status === 'authenticated') {
      showToast(bootError, 'error');
    }
  }, [bootError, status]);

  return (
    <>
      <AppRoutes />
      <ToastViewport />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <PwaInstallToast />
      <AppShell />
    </BrowserRouter>
  );
}
